<template>
  <van-popup v-model="visible" position="bottom" closeable round>
    <div class="popup-title">退保声明</div>
    <div class="content" ref="content">
      <h3>一、退保须知</h3>
      <p>1. 退保后，您就失去了保险保障。</p>
      <p>2. 退保后，如果您想再次投保，公司要按重新投保时实际年龄计算保费，年龄越大，保费可能越高。</p>
      <p>3. 退保后，如果您想再次投保，公司要考虑您的身体情况，若身体状况不佳，将会提高保险费或被拒保。</p>
      <p>4. 退保后，如果您想再次投保，根据条款的约定重新计算健康观察期。</p>
      <p>5. 若您在犹豫期过后解除保险合同，您会有一定的损失，我公司自收到解除合同申请之日起十日内，按照合同约定退还保单的现金价值（现金价值表附在正式保险合同之中）。</p>
      <p>6. 我公司按照规定开展客户退保回访工作，一般通过电话形式进行。为确保自己的权益得到切实保障，您应对回访问题进行如实答复。</p>
      <p>7.账户所有人必须以本人真实姓名开立结算账户，并自愿授权本公司使用指定银行账户（以下简称授权账户）用于退保金转账支付。</p>
      <p>8. 如果因授权人提供的授权账户错误、账户注销或者授权账户不符合本公司对授权账户要求而导致转账不成功，本公司无须承担由此引起的责任。</p>
      <p>9. 本公司不对该授权账户失窃或冒领承担责任。</p>
      <h3>二、风险提示书</h3>
      <p>新华人寿保险股份有限公司：</p>
      <p>本人在贵司投保的<{{$route.query.realPolicyNo}}>保险单，本人现向贵司申请办理退保业务。 本人确认贵司已进行了充分的风险提示，现确认如下：</p>
      <p>1. 本次办理的退保业务完全基于本人真实意愿及独立判断；</p>
      <p>2. 本人已充分知悉贵司从未授权各分支机构、保险代理人、公司员工或其他人员销售基金、信托、理财产品等非保险金融产品；已知悉贵司未与任何第三方理财机构进行合作、销售任何非保险金融产品；贵司未通过自营网络平台或第三方网络平台销售任何非保险金融产品。</p>
      <p>3.办理本次业务前，本人已充分评估非法集资风险（即未经国务院金融管理部门依法许可或者违反国家金融管理规定，以许诺还本付息或者给予其他投资回报等方式，向不特定对象吸收资金的行为所带来的风险），贵公司已经提示本人谨防该类风险。</p>
      <p>4. 本人承诺对本次退保资金使用风险承担一切责任。</p>
      <p>特此确认 ！</p>
      <h3>三、代扣协议</h3>
      <p>本人同意授权贵公司委托银行通过代扣方式从本人指定的银行账户按照保险合同约定的方式、金额收取首期及以后各期的应缴保险费等及以转账方式将保险金、退保金、退费等给付转入指定账户。</p>
    </div>
    <div class="btn" :class="{'gray': !isLook || time}" @click="ok">
      <span>知悉并同意以上内容</span>
      <span v-if="time">（{{time}}S）</span>
    </div>
  </van-popup>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {
      time: 10,
      timer: null,
      visible: false,
      isLook: false
    };
  },
  watch: {},
  computed: {},
  methods: {
    open() {
      this.visible = true;
      this.isLook = false;
      window.clearInterval(this.timer);
      this.startTimer();
      setTimeout(()=>{
        const a = this.$refs.content;
        a.onscroll = this.checkLook;
        this.checkLook();
      }, 1000);
    },
    startTimer() {
      this.time = 10;
      this.timer = setInterval(() => {
        this.time--;
        if (this.time <= 0 || !this.visible) {
          clearInterval(this.timer);
        }
      }, 1000);
    },
    // 检测是否阅读完毕
    checkLook() {
      const a = this.$refs.content;
      if (a.scrollTop + a.clientHeight >= a.scrollHeight - 30) {
        this.isLook = true;
      }
    },
    ok(){
      if(!this.isLook) {
        this.$notice.msg("请先阅读完退保声明");
        return;
      }
      if(this.time > 0) {
        return;
      }
      this.visible = false;
      this.$emit("ok");
    }
  }
};
</script>
<style lang="scss" scoped>
.popup-title {
  height: 100px;
  line-height: 100px;
  text-align: center;
  border-bottom: 1px solid #E7EAEC;
  font-size: 30px;
}
.content {
  width: 100%;
  max-height: 60vh;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  padding: 10px 40px 40px;
  * {
    max-width: 100%;
  }
  h3 {
    font-size: 28px;
    font-weight: bold;
    margin-top: 20px;
    margin-bottom: 1em;
  }
  p {
    font-size: 26px;
    margin-bottom: 1em;
  }
}
.btn {
  width: 690px;
  height: 90px;
  line-height: 90px;
  border-radius: 45px;
  text-align: center;
  background: #236DFF;
  font-size: 34px;
  color: #FFFFFF;
  margin: 30px;
  &.gray {
    opacity: 0.5;
  }
}
</style>